import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { UserProfile } from '../models/UserProfile';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {
  private readonly apiUrl = `${environment.apiBaseUrl}/Profile`;

  constructor(private http: HttpClient) {}

  /**
   * Loads the profile of the currently authenticated user.
   */
  getUserProfile(): Observable<UserProfile> {
    return this.http.get<UserProfile>(this.apiUrl);
  }

  /**
   * Updates the user's first and last name.
   * POST /Profile/Name
   */
  updateUserName(data: { firstName: string; lastName: string }): Observable<UserProfile> {
    return this.http.post<UserProfile>(`${this.apiUrl}/Name`, data);
  }

  /**
   * Ändert das Passwort des Users.
   * POST /Profile/Password
   * Request-Body:
   * {
   *   "currentPassword": "string",
   *   "newPassword": "string"
   * }
   */
  changePassword(payload: { currentPassword: string; newPassword: string }): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/Password`, payload);
  }
}
